import {
  FIND_A_PRO_RESULTS,
  FIND_A_PRO_STICKY_NAV,
} from "@/components/FindAProResults/v1/analytics/constanst"

const getProResultListEventInfo = data => {
  const {
    phone = "",
    url = "",
    partnerName = "",
    isEmail = false,
    needLocationFinderType = false,
    isForServiceProvider = false,
    staticTexts = {},
    selectedMenu = "",
    serviceProviderType = "",
  } = data
  const sleectedMenuName = selectedMenu ? selectedMenu : staticTexts?.designers
  const internalLinkName = isEmail
    ? "services@kohler.com"
    : phone || partnerName

  const type = phone
    ? "contact " + (isEmail ? "email" : "number")
    : isForServiceProvider
    ? "results"
    : partnerName

  let internalLinkType = "find a pro results:navigation"

  if (phone)
    internalLinkType = `find a pro results:contact:${partnerName}:${sleectedMenuName?.toLowerCase()}`

  if (needLocationFinderType)
    internalLinkType = `find a pro results:${sleectedMenuName?.toLowerCase()}`

  const serviceProviderName = serviceProviderType?.toLowerCase() || ""

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `${FIND_A_PRO_RESULTS}:${FIND_A_PRO_STICKY_NAV}:${selectedMenu?.toLowerCase()}:${
      phone || type
    }`,
    eventName: `${FIND_A_PRO_RESULTS}:${FIND_A_PRO_STICKY_NAV}:${selectedMenu?.toLowerCase()}:${
      phone || type
    }`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName,
    internalLinkPosition: FIND_A_PRO_RESULTS,
    internalLinkType,
    internalLinkURL:
      window.eventPageType === "find a pro results"
        ? "tel:" + phone
        : url || "n/a",
    internalLinkZoneName: `${FIND_A_PRO_RESULTS}:${serviceProviderName}`,
  }
  const page = window.pageObj || {}
  const datalayerObj = {
    event: "cmp:click",
    eventInfo,
    page,
  }
  window.adobeDataLayer.push(datalayerObj)
}

export { getProResultListEventInfo }
